import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';

const ScrollWrapper = styled.div`
  overflow-x:auto;-webkit-overflow-scrolling:touch;
  position:relative;border-radius:${p => p.theme.radius.md}px;
  &::after{
    content:'';position:absolute;top:0;right:0;bottom:0;width:20px;
    background:linear-gradient(to left,rgba(255,255,255,0.9),transparent);
    pointer-events:none;opacity:${p => p.$hasOverflow ? 1 : 0};
  }
`;
const Table = styled.table`
  width:100%;border-collapse:collapse;
  font-size:${p => p.theme.typography.sizes.sm};
`;
const THead = styled.thead`
  ${p => p.$sticky ? 'position:sticky;top:0;z-index:1;' : ''}
  background:${p => p.theme.colors.background};
`;
const Th = styled.th`
  padding:${p => p.$compact ? '6px 10px' : '10px 14px'};
  text-align:${p => p.$align || 'left'};
  font-weight:${p => p.theme.typography.weights.semibold};
  color:${p => p.theme.colors.text.primary};
  border-bottom:2px solid ${p => p.theme.colors.border};
  white-space:nowrap;
`;
const Tr = styled.tr`
  ${p => p.$retro ? `background:#fff3e0;` : p.$striped && p.$even ? `background:${p.theme.colors.background};` : ''}
`;
const Td = styled.td`
  padding:${p => p.$compact ? '6px 10px' : '10px 14px'};
  text-align:${p => p.$align || 'left'};
  border-bottom:1px solid ${p => p.theme.colors.border};
  color:${p => p.theme.colors.text.secondary};
`;

export default function ResponsiveTable({ columns, rows, stickyHeader = true, striped = true, compact = false }) {
  const wrapRef = useRef(null);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    const check = () => {
      const { scrollWidth, clientWidth, scrollLeft } = el;
      setFade(scrollWidth > clientWidth && scrollLeft + clientWidth < scrollWidth - 2);
    };
    check();
    const obs = new ResizeObserver(check);
    obs.observe(el);
    el.addEventListener('scroll', check);
    return () => { obs.disconnect(); el.removeEventListener('scroll', check); };
  }, []);

  return (
    <ScrollWrapper $hasOverflow={fade} ref={wrapRef}>
      <Table>
        <THead $sticky={stickyHeader}>
          <tr>
            {columns.map(col => (
              <Th key={col.key} $align={col.align} $compact={compact}>{col.label}</Th>
            ))}
          </tr>
        </THead>
        <tbody>
          {rows.map((row, i) => (
            <Tr key={i} $striped={striped} $even={i % 2 === 1}
                $retro={row.retrograde || row.is_retrograde}>
              {columns.map(col => (
                <Td key={col.key} $align={col.align} $compact={compact}>
                  {col.key === 'retrograde' && (row.retrograde || row.is_retrograde)
                    ? <span title="Retrograde">℞</span>
                    : (row[col.key] != null ? row[col.key] : '—')}
                </Td>
              ))}
            </Tr>
          ))}
        </tbody>
      </Table>
    </ScrollWrapper>
  );
}
